import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaEnvelope, FaClock, FaTruckMoving } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ServiceSection.css";
import translogo from "../../assets/images/trans2.jpg";
import { Link } from "react-router-dom";

export default function ServiceSection({
  showOnlyLast = false,
  isAfterHeroForm = false,
}) {
  const { t } = useTranslation();

  return (
    <section
      className={`py-5 bg-light ${isAfterHeroForm ? "section-after-hero-form" : ""}`}
    >
      <Container>
        {!showOnlyLast && (
          <>
            <Row className="mb-5 text-center">
              <Col>
                <h2 className="fw-bold text-orange">
                  {t("serviceSection.title")}
                </h2>
              </Col>
            </Row>

            <Row className="g-4 mb-5">
              {[
                {
                  number: "1",
                  title: t("serviceSection.cards.0.title"),
                  desc: t("serviceSection.cards.0.description"),
                },
                {
                  number: "2",
                  title: t("serviceSection.cards.1.title"),
                  desc: t("serviceSection.cards.1.description"),
                },
                {
                  number: "3",
                  title: t("serviceSection.cards.2.title"),
                  desc: t("serviceSection.cards.2.description"),
                },
                {
                  number: "4",
                  title: t("serviceSection.cards.3.title"),
                  desc: t("serviceSection.cards.3.description"),
                },
              ].map((step, idx) => (
                <Col md={3} sm={6} xs={12} key={idx}>
                  <div className="h-100 shadow-sm border-0 text-center p-3 rounded bg-white">
                    <h1 className="fw-bold text-orange">{step.number}</h1>
                    <h5 className="fw-bold">{step.title}</h5>
                    <p className="text-muted small">{step.desc}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </>
        )}

        <Row className="align-items-center g-4">
          <Col md={4} className="text-center">
            <img
              src={translogo}
              alt={t("serviceSection.imageAlt")}
              className="img-fluid rounded shadow"
            />
          </Col>
          <Col md={8}>
            <Row className="text-center align-items-start">
              <Col md={4} sm={6} xs={12} className="mb-4 d-flex flex-column">
                <FaEnvelope size={40} className="text-orange mb-3 m-auto" />
                <h6
                  className="fw-bold text-orange"
                  style={{ minHeight: "60px" }}
                >
                  {t("serviceSection.contact.title")}
                </h6>
                <p className="text-muted small" style={{ minHeight: "50px" }}>
                  {t("serviceSection.contact.description")}
                </p>
                <Link
                  to="/contact"
                  className="text-orange small text-decoration-underline mt-auto"
                >
                  {t("serviceSection.contact.link")} &gt;
                </Link>
              </Col>
              <Col md={4} sm={6} xs={12} className="mb-4 d-flex flex-column">
                <FaClock size={40} className="text-orange mb-3 m-auto" />
                <h6
                  className="fw-bold text-orange"
                  style={{ minHeight: "60px" }}
                >
                  {t("serviceSection.punctuality.title")}
                </h6>
                <p className="text-muted small" style={{ minHeight: "50px" }}>
                  {t("serviceSection.punctuality.description")}
                </p>
                <Link
                  to="#"
                  className="text-orange small text-decoration-underline mt-auto"
                >
                  {t("serviceSection.punctuality.link")} &gt;
                </Link>
              </Col>
              <Col md={4} sm={6} xs={12} className="mb-4 d-flex flex-column">
                <FaTruckMoving size={40} className="text-orange mb-3 m-auto" />
                <h6
                  className="fw-bold text-orange"
                  style={{ minHeight: "60px" }}
                >
                  {t("serviceSection.insurance.title")}
                </h6>
                <p className="text-muted small" style={{ minHeight: "50px" }}>
                  {t("serviceSection.insurance.description")}
                </p>
                <Link
                  to="#"
                  className="text-orange small text-decoration-underline mt-auto"
                >
                  {t("serviceSection.insurance.link")} &gt;
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
